import { isNullOrUndefined } from "@/utils/ts-utils"

type RelInfo = {
  isUserDefault?: boolean | null
}

export const getDefaultUserCollaborator = <TUserCollaborator extends RelInfo>(
  rels?: TUserCollaborator[]
) => {
  for (const rel of rels ?? []) {
    if (rel.isUserDefault) return rel
  }

  const v = rels?.[0]
  return isNullOrUndefined(v) ? undefined : v
}
